import React, { memo } from "react";
import { useFormContext } from "react-hook-form";
import useEvent from "../../../hooks/useEvent";
import { useModalActions } from "../ModalActionsContext";

const UploadButton = ({ baseName }) => {
  const { watch, setValue } = useFormContext();
  const { setImageState } = useModalActions();
  // Function to get current device time in YYYY-MM-DD HH:mm:ss
  const getCurrentDateTime = () => {
    const now = new Date();
    const pad = (n) => String(n).padStart(2, "0");
    return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ` +
      `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
  };
  const handleUpload = useEvent(() => {
    
    setImageState({
      field: `${baseName}.image`,
      setValue,
      watch,
    });
    // Set upload time field
    setValue(`${baseName}.upload_time`, getCurrentDateTime());
  });

  return (
    <button type="button" className="btnclass" onClick={handleUpload}>
      Upload
    </button>
  );
};

export default memo(UploadButton);
